import debug from 'debug';
import { camelCaseToDashCase, dashCaseToCamelCase } from 'Global/Shared/Components/Utils/Case';

const log = debug('Shared:BaseClass');

class BaseClass {
	constructor(element) {
		this.element = element;
		this.setClassName();

		log('BaseClass', this.className);
	}

	initDomCache() {
		this.dom = {};

		// Filter out ref's that embedded in another instance of the same behavior.
		const elements = [
			...this.element.querySelectorAll('[data-ref^=' + this.className + ']')
		].filter((element) => {
			const closestInstance = element.closest('[data-base-class*="' + this.className + '"]');
			return closestInstance === this.element;
		});

		log('InitDomCache elements:', elements);

		for (let a = 0; a < elements.length; a++) {
			const element = elements[a];
			const ref = element.getAttribute('data-ref');
			const key = dashCaseToCamelCase(ref).split('__')[1];

			if (key) {
				this.dom[key] = element;
			} else {
				// eslint-disable-next-line no-console
				console.error('DOM element cannot be correctly cached, have you used the correct pattern? Reference "' + ref + '" is expected to have the format "behavior-name__element-name"');
			}
		}
	}

	setClassName() {
		const className = camelCaseToDashCase(this.element.getAttribute('data-base-class'));
		this.className = className;
	}

}

export default BaseClass;
